import { render, staticRenderFns } from "./TravelQuoteSidebar.vue?vue&type=template&id=780827a7&scoped=true"
import script from "./TravelQuoteSidebar.vue?vue&type=script&lang=js"
export * from "./TravelQuoteSidebar.vue?vue&type=script&lang=js"
import style0 from "./TravelQuoteSidebar.vue?vue&type=style&index=0&id=780827a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780827a7",
  null
  
)

export default component.exports